import { VendorTransferPage } from "@/features/vendor-app/pages/VendorTransferPage";
import { createFileRoute } from "@tanstack/react-router";

type TransferSearch = {
	tab: "in" | "out";
	number?: string;
	dateStart?: string;
	dateEnd?: string;
	status?: string;
};

const str = (v: unknown): string | undefined =>
	typeof v === "string" && v !== "" ? v : undefined;

export const Route = createFileRoute("/vendor/transfer/")({
	validateSearch: (search: Record<string, unknown>): TransferSearch => ({
		tab: search.tab === "out" ? "out" : "in",
		number: str(search.number),
		dateStart: str(search.dateStart),
		dateEnd: str(search.dateEnd),
		status: str(search.status),
	}),
	component: VendorTransferPage,
});
